import React from "react";

import "./Links.css";
import Banner2 from "../../components/banner/Banner2";
import Btn1 from "../../components/btn/Btn1";
import { Link } from "react-router-dom";

const Links = () => {
  return (
    <section className="links">
      <Banner2></Banner2>
      <h2 className="text-2">aici începe schimbarea ta.</h2>
      <div className="btns">
        <a
          href="https://www.t.me/+aK5HWodRXbthZjRk"
          target="_blank"
          rel="noopener noreferrer"
        >
          <Btn1>Comunitate publică + PREMII</Btn1>
        </a>

        <Link to={"/trt"}>
          <Btn1>Terapie cu Testosteron (TRT)</Btn1>
        </Link>

        <Link to={"/tot"}>
          <Btn1>Optimizarea Testosteronului (TOT)</Btn1>
        </Link>

        <Link to={"/"}>
          <Btn1>Stero Care Website</Btn1>
        </Link>

        <a
          href="https://www.t.me/+aK5HWodRXbthZjRk"
          target="_blank"
          rel="noopener noreferrer"
        >
          <Btn1>PRODUSE</Btn1>
        </a>
      </div>
      <p>
        Intră in comunitatea publică pentru sfaturi, produse, premii (primul
        buton).
      </p>
    </section>
  );
};

export default Links;
